<script>
  /**
   * Import required external libraries here, including all
   * the data we need for ArchieML.
   */
  import archieml from 'archieml';
  import https from 'https';
  import * as d3 from 'd3';

  /**
   * Child components go here
   */
  import Loading from './Loading.svelte';
  import Map from './Map.svelte';
  import Intro from './Intro.svelte';
  import Page1 from './Page1.svelte';
  import Recirc from './Recirc.svelte';

  /**
   * Prop imports
   *
   * doc:  the google doc ID of the document that is used for
   * the copy. This component does not support authentication,
   * so make sure that the document is publicly accessible.
   */
  // eslint-disable-next-line
  export let doc;

  /**
   * Local variables
   */
  const url = `https://storage.googleapis.com/interactive-sheet/tiananmen-2019.txt`;
  let data = {};
  let worldJSON = {};
  let loadingContent = true;
  let loadingData = true;
  let error = false;

  /**
   * Fetch google doc data with an https request. Note:
   * Although this code would be easier with request,
   * rollup is unable to compile request for the client.
   */
  https.get(url, (resp) => {
    let ret = '';

     // A chunk of data has been recieved.
    resp.on('data', (chunk) => {
      ret += chunk;
    });

     // The whole response has been received. Load the result into data.
    resp.on('end', () => {
      data = Object.assign({}, data, archieml.load(ret));

      loadingContent = false;
    });
  }).on('error', (err) => {
    console.error(`Error: ${err.message}`);
    error = true;
  });

  Promise.all([
    d3.json('./world.geojson'),
  ])
    .then(([world]) => {
      worldJSON = world;
      loadingData = false;
    });
</script>

<style>
  .page {
    height: 100%;
    color: white;
  }
</style>

<div class="page">
  {#if loadingContent || loadingData}
    <Loading />
  {:else}
    <Intro data={data} />
    <Page1 data={data} />
    <Map data={data} worldJSON={worldJSON} />
    <Recirc data={data} />
  {/if}
</div>
